import ky from 'ky';

export const getAddressFromCoordinates = async (coordinates) => {
	const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coordinates.lat},${coordinates.lng}&key=${process.env.GOOGLE_API_KEY}`;
  const response = await ky.get(url).json();
  if (response.status !== 'OK' || !response.results?.length) return null;
  const first = response.results[0];
  const address = {
    formatted_address: first.formatted_address,
    place_id: first.place_id,
  };
  for (const comp of first.address_components || []) {
    const types = comp.types || [];
    if (types.includes('country')) {
      address.country = comp.long_name;
      address.countryCode = (comp.short_name || '').toUpperCase();
    }
    if (types.includes('administrative_area_level_1')) {
      address.admin1 = comp.long_name;
      address.admin1Code = (comp.short_name || '').toUpperCase();
    }
    if (types.includes('administrative_area_level_2')) {
      address.admin2 = comp.long_name;
      address.admin2Code = (comp.short_name || '').toUpperCase();
    }
    if (types.includes('postal_code')) {
      address.postalCode = comp.long_name;
    }
  }
  return address;
};
export const convertGoogleLatLng = (latLng) => ({ lat: latLng.lat(), lng: latLng.lng() });
